export default __webpack_public_path__ + "static/media/28mmyellowhpde.1750e25c.jpg";